import React from 'react';
import { Layers, Repeat2, Star, Trophy } from 'lucide-react';
import { buildVocabularyProgressCounts, vocabularyGrade } from '../utils/vocabularyPresentation';
import PracticeSummaryProgress from './PracticeSummaryProgress';
import { formatCompactInteger } from '../utils/numberFormat';
import { t } from '../i18n';
import './NoteStatsPanel.css';

export default function VocabularyNoteStats({ cards, title }) {
  const count = cards.length;
  const average = field => count ? cards.reduce((sum, card) => sum + (Number(card[field]) || 0), 0) / count : 0;
  const grade = count ? cards.reduce((sum, card) => sum + vocabularyGrade(card), 0) / count : 0;
  const progress = buildVocabularyProgressCounts(cards);
  const excluded = count - progress.total;
  const metrics = [['cards', count, Layers], ['repeats', formatCompactInteger(average('repeatCount')), Repeat2],
    ['score', formatCompactInteger(average('totalPoints')), Trophy], ['grade', grade.toFixed(1), Star]];
  return <section className="note-stats-panel" aria-label={t('learningNavigation.stats.accessibleTitle', undefined, { name: title })}>
    <div className="note-stats-summary-grid">{metrics.map(([key, value, Icon]) => <div className="note-stats-stat" key={key}>
      <Icon className="note-stats-stat-icon" size={22} aria-hidden="true" /><span className="note-stats-stat-value">{value}</span><span className="note-stats-stat-label">{t(`learningNavigation.stats.${key}`)}</span>
    </div>)}</div>
    <PracticeSummaryProgress counts={progress} stageLabels={{ testing: t('vocabulary.progressFinishing') }}
      description={t('vocabulary.progressDescription')} compositionLabel={t('vocabulary.progressComposition', undefined, progress)} />
    {excluded > 0 && <p className="vocabulary-progress-excluded">{t('vocabulary.progressExcluded', undefined, { count: excluded })}</p>}
  </section>;
}
